import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TextBoxComponent } from "./textbox.component";

@NgModule({
  imports: [CommonModule],
  declarations: [TextBoxComponent],
  exports: [TextBoxComponent]
})
export class TextBoxModule {}
